import { render } from "./CSurveyMainInfo.vue?vue&type=template&id=774534e7&ts=true"
import script from "./CSurveyMainInfo.ts?vue&type=script&lang=ts"
export * from "./CSurveyMainInfo.ts?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__